export function isValidZip(zip: string) {
    return /^[0-9]{5}(?:-[0-9]{4})?$/.test(zip);
}

export function isValidPhoneWithExtension(phone: string) {
    return /^[2-9]\d{2}[. -]?[2-9]\d{2}[. -]?\d{4}/.test(phone);
}

export function formatPhoneNumber(number: string | nullish) {
    // Remove any leading 1
    const trimmed = number ? number.replace(/^1?(.*)$/, '$1') : '';
    // If the number is nullish or not a 3-10 digit only string, return the original number.
    if (!number || !/^\d{3,10}$/.test(trimmed)) {
        return number;
    }
    // If the number is short partly format it
    if (/^\d{3,6}$/.test(trimmed)) {
        return trimmed?.replace(/^(\d{3})(\d+)$/, '($1) $2');
    }
    return trimmed?.replace(/^(\d{3})(\d{3})(\d{0,4})$/, '($1) $2-$3');
}

export function isValidPhoneNumber(number: string | nullish) {
    return number?.replace(/\D/g, '').length === 10;
}
